import { render, staticRenderFns } from "./bag-model-details-presc-btn.vue?vue&type=template&id=22ffc812&lang=pug&"
import script from "./bag-model-details-presc-btn.vue?vue&type=script&lang=ts&"
export * from "./bag-model-details-presc-btn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports